import request from '@/utils/request.js'

export function getbuydetail(data) {
  return request.get('/api/H5/order/getbuydetail', {
    params: data
  })
}

export function getbuycartdetail(data) {
  return request.get('/api/H5/order/getbuycartdetail', {
    params: data
  })
}

export function addorder(data) {
  return request.post('/api/H5/order/addorder', data)
}

export function getwxpay(data) {
  return request.get('/api/H5/order/getwxpay', {
    params: data
  })
}

export function getpayurl(data) {
  return request.get('/api/H5/order/getpayurl', {
    params: data
  })
}

export function getbuyexchangeorderpay(data) {
  return request.get('/api/H5/order/getbuyexchangeorderpay', {
    params: data
  })
}

// 月卡订单信息
export function getbuycardorderinfo(data) {
  return request.get('/api/H5/order/getbuycardorderinfo', {
    params: data
  })
}
